app.directive('inputMask', ['$filter', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, element, attrs, ctrl) {
            function inputValue(val) {
                if (!val) return 0;
                val = val.toString();

                var digits = val.replace(/[^0-9.]/g, '');

                if (digits.split('.').length > 2) {
                    digits = digits.substring(0, digits.length - 1);
                }

                if (attrs.inputMaskMax && parseFloat(digits) > parseFloat(attrs.inputMaskMax)) {
                    digits = ctrl.$modelValue.toString();
                }

                /*if (attrs.inputMaskMin && parseFloat(digits) < parseFloat(attrs.inputMaskMin)) {
                    digits = ctrl.$modelValue.toString();
                }*/

                if (digits !== val) {
                    ctrl.$setViewValue(digits);
                    ctrl.$render();
                }

                return parseFloat(digits);
            }

            ctrl.$parsers.push(inputValue);
        }
    };
}]);